export default __webpack_public_path__ + "static/media/024-lifebuoy.0dedcd67.png";